import React from "react";
import { SearchBar } from "../SearchBar";

export function Content() {
  return (
    <div className="content">
      <SearchBar />
    </div>
  );
}
